/**
 *  定义Model对象,包含所有的数据结构(请求，响应)
 */
import RequestJson from '../model/RequestJson'
import ResponseJson from '../model/ResponseJson'
import { HttpUtil } from 'wbap-utils'
import { observable, action } from 'mobx'
import { UserStore, RouterStore, UIStore } from './index'

export default class JsonModel {

  @observable dsJson = new Map()        //当前上下文数据集{sid:'', rows:[]}
  @observable backupDSJson = new Map()  //备份数据用于比较差异

  constructor () {
    this.request = new RequestJson()    //请求对象
    this.response = new ResponseJson()  //响应对象
    this.UserStore = UserStore
    this.RouterStore = RouterStore
    this.UIStore = UIStore
  }

  /*
   * 数据提交
   */
  async commit () {
    console.log('-------------请求JSON报文---------------')
    console.log(JSON.stringify(this.request))
    console.log('----------------------------------------------')
    try {
      let result = await HttpUtil.post('http://111.198.86.222/BAP/OpenApi', this.request)
      if (!result || !result.data) {
        // Toast.info('网络异常')
        console.log('网络异常')
        return false
      }
      if (result.data.JsonResult.toString().toLowerCase() === 'false') {
        // Toast.info(result.data.JsonMessage.MessageInfo)
        console.log('error ==>' + result.data.JsonMessage.MessageInfo)
        return false
      }
      this.response.JsonResult = result.data.JsonResult
      this.response.JsonMessage = result.data.JsonMessage
      this.response.JsonData = result.data.JsonData
      console.log('--------返回JSON数据-----------')
      console.log(JSON.stringify(this.response))
      console.log('----------------------------------------------')
      //把数据复制到新的数据集中
      this._copyToDSJson()
      //把数据复制备份一份
      this._copyToBackup()
      return true
    } catch (error) {
      console.log(error)
    }
  }

  /**
   * 通过SQLBuilderID取相应的数据
   * @param _sid
   * @returns {*}
   */
  tableJson (_sid) {
    if (_sid && this.dsJson.has(_sid)) {
      return this.dsJson.get(_sid)
    }
    return []
  }

  /**
   * 通过SQLBuilderID取相应的数据
   * @param _sid
   * @returns {*}
   */
  backupJson (_sid) {
    if (_sid && this.backupDSJson.has(_sid)) {
      return this.backupDSJson.get(_sid)
    }
    return []
  }

  /**
   * 把返回的数据复制到数据集
   * @private
   */
  @action
  _copyToDSJson () {
    for (let _data of this.response.JsonData) {
      let _sid = _data.SQLBuilderID
      let _rows = []
      //有数据,循环存入新的数据源
      if (_data.ROW && _data.ROW.length > 0) {
        _data.ROW.map((item) => {
          _rows.push(item)
        })
      }
      //先清空
      this.clearRow(_sid)
      //加入到map中
      this.dsJson.set(_sid, _rows)
    }
  }

  /**
   * 添加新行
   * @param sid
   * @param rows
   */
  @action
  addRow (_sid, _row) {
    if (!this.dsJson.has(_sid)) {
      this.dsJson.set(_sid, [])
    }
    this.dsJson.get(_sid).push(_row)
  }

  /**
   * 删除
   * @param _sid
   * @param _row
   */
  @action
  deleteRow (_sid, _row) {
    let _data = this.tableJson(_sid)
    if (_data.length < 1) return
    let _index = _data.findIndex(row => row.FMID === _row.FMID)
    if (_index < 0) return
    _data.splice(_index, 1)
  }

  /**
   * 清空
   * @param _sid
   */
  @action
  clearRow (_sid) {
    let _data = this.tableJson(_sid)
    if (_data.length < 1) return
    _data.splice(0, _data.length)
  }

  /**
   * 备份数据
   * @private
   */
  _copyToBackup () {
    this.backupDSJson.clear()
    let {keys} = Object
    for (let [k, v] of this.dsJson) {
      if (!v || v.length < 1) continue
      let _rows = []
      let _keys = keys(v[0])  //取第一个
      v.map((_row) => {
        //创建新对象
        let _newRow = {}
        for (let _key of _keys) {
          _newRow[_key] = _row[_key]
        }
        _rows.push(_newRow)
      })
      this.backupDSJson.set(k, _rows)
    }
  }
}



// WEBPACK FOOTER //
// ./src/wbap-core-commit/store/JsonModel.js